"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import StackedContentComponent from "../ui/StackedContentComponent";
import { getGap, getPaddings } from "@/utils/theme-helper";

const SplitContentSectionComponent: React.FC<
  SectionProps<{
    padding: string;
    gap: string;
    leftContent: any;
    rightContent: any;
  }>
> = ({ cmsSection, index, cmsData, app }) => {
  const getSizeClassName = () => {
    switch (cmsSection.ui?.contentWidth) {
      case "lg":
        return "max-w-screen-lg";
      case "xl":
        return "max-w-screen-xl";
      case "2xl":
        return "max-w-screen-2xl";
      case "4xl":
        return "max-w-screen-4xl";
      case "full":
        return "w-full";
      default:
        return "max-w-screen-xl";
    }
  };

  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "4xl",
        padding: "none",
      })}
    >
      <style>
        {`.section-${index}  {
          --left-content-width: ${cmsSection.specifics.leftContent.width};
          --right-content-width: ${cmsSection.specifics.rightContent.width};
              }`}
      </style>
      <div className={`flex flex-1 h-full justify-center section-${index}`}>
        <div className={`${getSizeClassName()} `}>
          <div
            className={`flex md:flex-row h-full ${
              cmsSection.specifics?.leftContent.mobilePosition === "bottom"
                ? "flex-col-reverse"
                : "flex-col"
            } ${getPaddings(cmsSection.specifics.padding)} ${getGap(cmsSection.specifics.gap)}`}
          >
            <div
              className="h-full relative flex md:w-[var(--left-content-width)] w-full"
              style={{
                backgroundColor: cmsSection.specifics.leftContent.bgColor,
              }}
            >
              <StackedContentComponent
                cmsData={cmsData}
                config={cmsSection.specifics.leftContent}
                index={index}
                app={app}
                cmsSection={cmsSection}
              />
            </div>
            <div
              className="h-full flex md:w-[var(--right-content-width)] w-full"
              style={{
                backgroundColor: cmsSection.specifics.rightContent.bgColor,
              }}
            >
              <StackedContentComponent
                cmsData={cmsData}
                config={cmsSection.specifics.rightContent}
                index={index}
                app={app}
                cmsSection={cmsSection}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default SplitContentSectionComponent;
